import React from 'react';

import Chip from 'components/Chip';

import { colors } from 'theme/colors';

const ArchivedPill: React.FunctionComponent = () => (
  <Chip
    label="Archived"
    size="small"
    capitalizeLabel={false}
    colors={{ background: colors.grey[200], foreground: colors.common.black }}
    data-testid="archived-pill"
  />
);

export default ArchivedPill;
